// extracted by mini-css-extract-plugin
export default {"btn":"LPButton_btn__iA54a","lineButton":"LPButton_lineButton__IN8+P"};